// Recommendation API

import axios from 'axios';

export const retrieveIrrigationRecommendationsForUser = async () => (
  axios.get('/api/recommendations/')
);

export const retrieveIrrigationRecommendationForBlock = async ({ blockId }) => (
  axios.get(`/api/recommendations/block/${blockId}`)
);


export const retrieveIrrigationRecommendation = async ({ id }) => (
  axios.get(`/api/recommendations/${id}/`)
);

export const patchIrrigationRecommendation = async ({ id, type, data }) => (
  axios.patch(`/api/recommendations/${type}/${id}/`, data)
);

export const retrieveIrrigationRecommendationStatus = async ({ id }) => (
  axios.get(`/api/recommendations/${id}/status/`)
);

export const createRecommendationSchedule = async (data) => (
  axios.post('/api/recommendations/schedule/update/', data)
);
